import { Icon, IconProps } from './Icon';

export type RenderProps = IconProps;

export const Render = (props: RenderProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M8 1.333c.394 0 .78.035 1.157.1M8 1.333a6.667 6.667 0 0 0 0 13.334M8 1.333v13.334m3.825-12.128a6.705 6.705 0 0 1 1.637 1.638m1.105 2.667a6.716 6.716 0 0 1 0 2.312m-1.108 2.671c-.445.635-1 1.189-1.634 1.634m-2.67 1.106c-.375.066-.761.1-1.155.1" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
